'use client';

import { AlertBanner } from '@/lib/mx-asurion-ui-react';
import { ReactNode, useEffect, useMemo, useState } from 'react';
import { Alert, AlertContext } from './AlertContext';

interface AlertProviderProps {
  children?: ReactNode;
  className?: string;
  display?: 'banner' | 'inline' | undefined;
  icon?: string;
  hideDismissButton?: boolean;
}

export default function AlertProvider({
  children,
  className,
  display,
  icon,
  hideDismissButton,
}: AlertProviderProps) {
  const [isClient, setIsClient] = useState(false);

  const [alert, setAlert] = useState<Alert>({ message: null, type: 'default' });
  const contextValue = useMemo(
    () => ({
      alert,
      setAlert,
    }),
    [alert],
  );

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <AlertContext.Provider value={contextValue}>
      {isClient ? (
        <div className={className}>
          <AlertBanner
            alertBannerType={alert.type}
            isOpen={!!alert.message}
            onCloseClick={() => {
              setAlert({ message: null, type: 'default' });
            }}
            display={display}
            iconSrc={icon}
            hideDismissButton={hideDismissButton ?? false}
          >
            {alert.message}
          </AlertBanner>
        </div>
      ) : null}
      {children}
    </AlertContext.Provider>
  );
}
